const actions = {
  LOAD_HELPVIDEOS_LIST: 'LOAD_HELPVIDEOS_LIST',
  LOAD_HELPVIDEOS_LIST_SUCCESS: 'LOAD_HELPVIDEOS_LIST_SUCCESS',
  SAVE_HELPVIDEOS_LIST: 'SAVE_HELPVIDEOS_LIST',

  LOAD_API_ERROR: 'LOAD_API_ERROR',
  SAVE_API_ERROR: 'SAVE_API_ERROR',

  loadHelpvideosApi: (pagination, data) => {
    return { type: actions.LOAD_HELPVIDEOS_LIST, pagination, data };
  },
  loadHelpvideosApiSuccess: (pagination, data) => ({
    type: actions.LOAD_HELPVIDEOS_LIST_SUCCESS,
    payload: { pagination, data }
  }),
  loadApiError: (error) => ({
    type: actions.LOAD_API_ERROR,
    payload: { error }
  }),
  saveApiError: (error) => ({
    type: actions.SAVE_API_ERROR,
    payload: { error }
  })
};

export default actions;
